import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { getFeatureFlags } from 'utils/featureFlags/selectors';
import { getPayeesForAccounts } from 'data/payees/selectors';
import {fieldIsEditable } from 'components/TransactionRegister/helpers';
import { getFieldString, makeTagsString } from 'data/transactions/searchFilter';
import { getDatasetId } from 'utils/auth/selectors';
import { getDatasetsById } from 'data/datasets/selectors';
import { getScheduledTransactions } from 'data/scheduledTransactions/scheduledTransactionsSelectors';
import { isWindowsDataset } from 'data/datasets/utils';
import { isSplitTxn, getTxnDifferences, txnHasTags, getTxnStateInfo, isNextScheduledInstance, transactionEditsNotAllowed,
  isUnacceptedScheduledTxn, isUncategorizedTxn, isPendingTxn, nextScheduledInstanceAfterDate } from 'data/transactions/utils';

import { txnCategorySign } from 'data/transactions/preProcess';
import { getAccountString } from 'data/accounts/retrievers';
import { getTransactionsByAccountId } from 'data/transactions/selectors';

import * as preferencesSelectors from 'data/preferences/selectors';

import QIconButton from 'components/QIconButton';
import QMenu from 'components/QMenu';
import AmountField from 'components/QuickenControls/AmountField/index';
import DateField from 'components/QuickenControls/DateField/index';
import IgnoredField from 'components/IgnoredField';
import SplitsAndDetailsPanel from 'components/SplitsAndDetailsPanel';
import TagsField from 'components/QuickenControls/TagsField';
import QCurrency from 'components/QCurrency';
import QHelp from 'components/QHelp';
import QPreferences from 'components/QPreferences';
import AccountsMenu from 'components/QuickenControls/AccountsMenu';
import PayeeField from 'components/QuickenControls/PayeeField';
import ClrField from 'components/QuickenControls/ClrField';
import FlagField from 'components/QuickenControls/FlagField';
import QDialogs from 'components/QDialogs';

import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import ButtonBase from '@material-ui/core/ButtonBase';
import MUISplitIcon from '@material-ui/icons/CallSplit';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import ManualIcon from '@material-ui/icons/Create';
import DownloadedIcon from '@material-ui/icons/AccountBalance';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import SaveIcon from '@material-ui/icons/Save';
import FastCatIcon from '@material-ui/icons/FlashOn';
import CloseIcon from '@material-ui/icons/Close';
import AlarmOn from '@material-ui/icons/AlarmOn';

import QTip from 'components/QuickenControls/QTip';
import 'react-tippy/dist/tippy.css';

import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import QCheckbox from 'components/QCheckbox';

import TextField from '@material-ui/core/TextField';
import { isOldEdge } from 'utils/utils';


import QTypography from 'components/MUIWrappers/QTypography';
import { getLogger } from 'utils/logger';

import { isAcme } from 'isAcme';

import { RegTxList, RegTxListRow, RegListItem, styles } from './styles';

// THE FIELDS
import RegCategoryField from './components/RegCategoryField';


const log = getLogger('components/TransactionRegister/TransactionRow/index.js');
const isIe = require('is-iexplorer') || isOldEdge();  // eslint-disable-line

let SHOW_ALL = false;

class TransactionRow extends PureComponent { // eslint-disable-line react/prefer-stateless-function

  constructor(props) {
    super(props);

    const dataset = this.props.datasetsById.get(this.props.datasetId);

    this.state = {
      currencySymbol: props.showCurrencySymbol ? props.getTxnCurrency(props.txn) : 'N/A',
      accountMenuEl: null,
      prevTxn: props.txn, // keep track of starting point of editable for comparison on save
      isWindowsDataset: isWindowsDataset(dataset), // prevents re-render for simplifi
      showIcons: false,
    };
  }

  componentDidMount() {
    this.initDatasetClientCreator();
  }

  componentWillReceiveProps(nextProps) {

    // log.log('TRANSACTION ROW--------------------------------------------------------');
    // Object.keys(nextProps).forEach((key) => {
    //   if (nextProps[key] !== this.props[key]) {
    //     log.debug(`keyvalue ${key} changed`);
    //   }
    // });


    if ((this.props.showCurrencySymbol !== nextProps.showCurrencySymbol) ||
        this.props.txn !== nextProps.txn) {
      this.setState({ currencySymbol: nextProps.showCurrencySymbol ? nextProps.getTxnCurrency(nextProps.txn) : 'N/A' });
    }
    // keep track of the baseline editable transaction for comparison
    if (this.props.editable !== nextProps.editable) {
      this.setState({ prevTxn: nextProps.txn });
    }
    if ((this.props.datasetsById !== nextProps.datasetsById) || (this.props.datasetId !== nextProps.datasetId)) {
      this.initDatasetClientCreator();
    }
  }

  componentDidUpdate() {
    if (this.props.onFocusField && this.focusField) {
      this.props.onFocusField(this.focusField);
    }
  }

  initDatasetClientCreator = () => {

    if (this.props.datasetId) {
      const dataset = this.props.datasetsById.get(this.props.datasetId);
      if (dataset) {
        this.setState({ isWindowsDataset: isWindowsDataset(dataset) });
      }
    }
  };

  onRowSelect = (id, value) => {
    this.props.onRowSelect(id, value);
  };


  //
  // This processes the "SAVE" call from the details panels (splits and/or edit details)
  // We give each of those a copy of the txnBeingEdited so that cancel is easy enough, but
  // it is possible that the user can edit the txnBeingEdited from the transaction row while
  // splits and details are open, which can lead to the transaction fields being edited from
  // two places at once.  We need to a) not lose any edited data from the transaction row, and
  // b) resolve conflicts if the data is edited both places.  In this case, the main txn field
  // wins.
  //
  saveTransaction = (editedTxn, autoSave, txnDirty) => {

    const { prevTxn } = this.state;
    const txnBeingEdited = this.props.txn;
    const newTxn = editedTxn;
    let localDirtyFlag = false;

    const changed = getTxnDifferences(txnBeingEdited, prevTxn);

    // if user changed memo, tags, payee, coa, postedOn, or check number, then we use the
    // version from the main transaction instead of the details panel.  Exception, if tx is split
    // we ignore the apparent coa change
    //

    changed.forEach((fld) => {
      switch (fld) {
        case 'postedOn':
        case 'memo':
        case 'check':
        case 'state':
        case 'payee':
          newTxn[fld] = txnBeingEdited[fld];
          localDirtyFlag = true;
          break;

        case 'split':
          localDirtyFlag = true;
          break;

        case 'amount':
        case 'tags':
        case 'coa':
          if (!isSplitTxn(newTxn)) {
            newTxn[fld] = txnBeingEdited[fld] || newTxn[fld];  // don't ever purposefully assign null
            localDirtyFlag = true;
          }
          break;

        default:
          break;
      }
    });

    this.props.callbacks.saveTransaction(newTxn, autoSave, txnDirty || localDirtyFlag);

  };

  itemKeydown = (e, fld, txn) => {
    if (e.key === ' ' || e.key === 'Enter') {
      e.stopPropagation();
      this.props.callbacks.regFieldClick(fld, txn);
    }
  };

  // Props must have:
  // accountIds, editRunningBalance, regEditableFields, headerFields, editDownloaded
  // showAccountColors, showSplitWindow, scheduledTransactionsById, txnExtraColumn
  fieldIsEditable = (txn, fld) => {

    const { accountIds, editRunningBalance, scheduledTransactionsById, editDownloaded, txnCancelExtraColumn,
      showAccountColors, headerFields, regEditableFields, showSplitWindow } = this.props;

    const options = {
      accountIds, editRunningBalance, scheduledTransactionsById, editDownloaded, txnCancelExtraColumn, showAccountColors,
      headerFields, regEditableFields, showSplitWindow,
    };

    if (isAcme || !isUnacceptedScheduledTxn(txn)) {
      return fieldIsEditable(txn, fld, options);
    }
    return isNextScheduledInstance(txn, this.props.scheduledTransactionsById) && fieldIsEditable(txn, fld, options);
  };

  renderReviewedState = (txn, classes, fieldActive, forceStatic) => {

    let title;
    if (this.state.isWindowsDataset) {

      if (this.props.userPreferences.windowsReviewedWarningEnabled) {
        title = 'Click here to learn what this is and how to use it';
      } else {
        title = txn.isReviewed
          ? "Transaction 'Accepted', click to undo 'Accept' (Learn more in Transactions Settings -> Show/Hide Columns)"
          : "Transaction 'Not Accepted', click to mark 'Accepted' (Learn more in Transactions Settings -> Show/Hide Columns)";
      }
    } else {
      title = txn.isReviewed
        ? "Transaction marked 'reviewed', click to mark 'not reviewed"
        : "Transaction marked 'Not reviewed', click to mark 'reviewed'";
    }

    return (
      <QIconButton
        aria-label="Set Reviewed State"
        buttonRef={fieldActive ? (input) => { this.focusField = input; } : null}
        disabled={forceStatic}
        autoFocus={fieldActive}
        focusRipple
        IconComponent={CheckCircleIcon}
        IconProps={{ className: classNames(classes.reviewed, txn.isReviewed ? 'reviewed' : 'not-reviewed') }}
        size="small-target"
        tooltip={title}
      />
    );
  };

  renderMatchState = (txn, classes, _handleMenu) => {

    let txnState = getTxnStateInfo(txn).entry;

    if (!isAcme && txnState === 'scheduled') {
      txnState = 'blank';
    }
    switch (txnState) {

      case 'bank':
        return (
          <QTip
            title="Bank downloaded transaction"
            wrapId={`${txn.id}-match`}
          >
            <DownloadedIcon
              className={classNames(classes.matchStateIcon, txnState)}
            />
          </QTip>
        );
      case 'manual':
        return (
          <QTip
            title="Manually entered transaction"
            wrapId={`${txn.id}-match`}
          >
            <ManualIcon
              className={classNames(classes.matchStateIcon, txnState)}
            />
          </QTip>
        );
      case 'matched':
        return (
          <QTip
            title="Matched transaction"
            wrapId={`${txn.id}-match`}
          >
            <DownloadedIcon
              className={classNames(classes.matchStateIcon, txnState)}
            />
          </QTip>
        );
      case 'scheduled':
        return (
          <QTip
            title="Scheduled transaction"
            wrapId={`${txn.id}-match`}
          >
            <AlarmOn
              className={classNames(classes.matchStateIcon, txnState)}
            />
          </QTip>
        );
      default:
        return (
          ''
        );
    }

  };

  renderRecurringField = (options) => {

    const {txn, fieldActive, onChange } = options;

    const accountTransactions = this.props.transactionsByAccountId.get(txn.accountId);
    let qtipTitle = null;
    const recurringStatus = getTxnStateInfo(txn);

    const nextInstance = accountTransactions &&
      nextScheduledInstanceAfterDate(moment(), accountTransactions, txn.stModelId);
    const isNext = nextInstance && nextInstance.id === txn.id;

    let menuOptions = isNext ?
      [
        { label: 'Enter this reminder', value: 'ACCEPT' },
        { label: 'Ignore this reminder', value: 'SKIP' },
      ]
      :
      [
        { label: 'Enter this and all previous overdue reminders for this Payee as Paid', value: 'ACCEPT' },
        { label: 'Ignore this and all previous overdue reminders for this Payee', value: 'SKIP' },
      ];

    let iconClass = '';

    switch (recurringStatus.status) {

      case 'DUE':
        qtipTitle = 'This reminder is due';
        iconClass = 'due';
        break;

      case 'OVERDUE':
        qtipTitle = 'This reminder is overdue';
        iconClass = 'overdue';
        break;

      default:
        if (isNext) {
          qtipTitle = 'This will be the next instance that becomes due';
        } else {
          qtipTitle = 'This reminder is not yet due';
          iconClass = 'notdue';
          menuOptions = null;
        }
        break;
    }

    // if this scheduled instance contains transfers to unsynced accounts, then do not allow the user to act
    if (transactionEditsNotAllowed(txn)) {
      qtipTitle = 'This scheduled instance is a billpay transaction, or contains a transfer to an unsynced account ' +
        'or account that does not support transactions.' +
        ' You can only edit or act upon it from the desktop application';
      menuOptions = null;
    }
    const customTrigger = (
      <AlarmOn className={this.props.classes[iconClass]}/>
    );

    if (menuOptions) {
      return (
        <QMenu
          customTrigger={customTrigger}
          name={`${txn.id}-recurring`}
          title={qtipTitle}
          menuIconButtonSize="mediumNoPadding"
          autoFocus={fieldActive}
          options={menuOptions}
          onChange={onChange}
          buttonRef={fieldActive ? (x) => {
            this.focusField = x
          } : null}
        />
      );
    }
    return(
      <QTip
        title={qtipTitle}
        wrapId={`${txn.id}-recurring`}
      >
        {customTrigger}
      </QTip>
    );
  };


  // Handles the interplay between MoneyOut and MoneyIn fields
  // What we are going for is a seamless usage of these fields across a single transaction amount
  // First, since we use an AmountField component both for the static and editable states, we need
  // to manage the values/properties appropriatly based on the value of the transaction. We also want
  // behavior to be elegant, so when the user starts typing in one field, the other field blanks out
  // (but not before the user types).  WE use the '&' character to represent zero/blank fields, which
  // provides an actual value, but gets validated into a null.  Null itself would prevent a component update
  //
  renderDoubleAmountField = (
    field,
    amountEditable,
    enableAutoFocus,
    attributes,
  ) => {

    const { editable, txn, currEditFieldName, callbacks, classes } = this.props;
    const { currencySymbol } = this.state;

    const rowBeingEdited = editable;
    const thisFieldActive = (amountEditable && rowBeingEdited && (currEditFieldName === field));

    const classString = classNames('amount',
      this.props.classes.regItem, 'protectWidth', thisFieldActive ? 'editable' : '');

    let value = '0';
    if (thisFieldActive) {
      //
      // we need to just pass through the current txn amount string
      const amountValid = (field === 'expense') ? txn.amount <= 0 : txn.amount > 0;
      value = amountValid ? txn.amount : '&';

    } else {
      const amountValid = (field === 'expense') ? txn.amount <= 0 : txn.amount > 0;
      value = amountValid ? Math.abs(txn.amount) : '&';
    }
    const zeroIsBlank = txn.amount === 0 ? (field !== 'expense') : true;

    // note, no BLUR handling here, otherwise it breaks by causing 0 values to wipe out partner field
    //
    return (
      <RegListItem
        {...attributes}
        className={classString}
      >
        {SHOW_ALL &&
        <AmountField
          disableUnderline={this.props.theme.components.register.noUnderline}
          clickable={amountEditable ? 'true' : null}
          amountType={field}
          onChange={callbacks.handleChange}
          onBlur={(e) => {
            callbacks.onAmountBlur(e, field);
          }}
          editable={thisFieldActive}
          autoFocus={enableAutoFocus}
          fontSize={this.props.theme.components.register.fontSize.default}
          value={String(value)}
          color={field === 'expense' ? 'black' : 'green'}
          useAbsoluteValue={field === 'expense' ? true : null}
          zeroIsBlank={zeroIsBlank}
          className={classNames(classes.regInput, 'amount')}
          currencySymbol={currencySymbol}
          inputRef={thisFieldActive ?
            (input) => {
              this.focusField = input;
            } : null}
        >
        </AmountField>
        }
      </RegListItem>
    );
  };

  renderAccountField(options) {

    const { attributes, retRow, fieldActive, wrapClass, classes, callbacks, forceStatic, txn, editable } = options;

    const flexClass = this.props.showAccountColors ? 'none' : 'flex1 protectWidth';
    const regClass = this.props.showAccountColors ? '' : this.props.classes.regItem;
    const acctName = getAccountString(txn.accountId);

    // only allow editing if this is NOT a bank downloaded transaction
    const allowEditing = editable; // && this.fieldIsEditable(txn, 'account');

    function renderCore(showColorBar, accountColorForId) {
      return (
        <>
          {showColorBar &&
            <div
              className={classes.accountFieldColor}
            >
              <div
                style={{
                  height: '100%',
                  minHeight: 20,
                  width: '40%',
                  background: accountColorForId,
                }}
              >
              </div>
            </div>
          }
          {!showColorBar &&
            <div
              className={classes.accountFieldName}
            >
              <QTip
                title={acctName}
                distance={3}
                wrapOnly
                position="bottom"
                wrapId={`${txn.id}-account`}
              >
                <QTypography
                  thinFont
                  clickable
                  className={classes.regItemCore}
                >
                  {acctName}
                </QTypography>
              </QTip>
            </div>
          }
        </>
      );
    }

    retRow.push(
      <RegListItem
        {...attributes}
        className={classNames(fieldActive && 'editable', regClass, flexClass, fieldActive ? 'wraptext' : wrapClass)}
        tabIndex="0"
      >
        {SHOW_ALL &&
          <>
            {allowEditing &&
            <ButtonBase
              id={`${this.props.showAccountColors ? 'AcctColorMenu' : 'AcctMenu'}${txn.id}`}
              aria-label="Account Menu"
              classes={{ root: classes.buttonRoot }}
              focusRipple
              autoFocus
              disabled={forceStatic}
              buttonRef={fieldActive ? (input) => {
                this.focusField = input;
              } : null}
              onClick={fieldActive ? (e) =>
                this.setState({ accountMenuEl: e.currentTarget }) : null}
            >

              {renderCore(this.props.showAccountColors, this.props.accountColorForId)}

            </ButtonBase>
            }
            {!allowEditing &&
            <>
              {renderCore(this.props.showAccountColors, this.props.accountColorForId)}
            </>
            }

            {allowEditing && // lastRow &&
            <>
              {fieldActive && this.state.accountMenuEl &&
              <AccountsMenu
                element={this.state.accountMenuEl}
                selected={txn.accountId}
                showColors={this.props.showAccountColors}
                onChange={(event) => {
                  this.setState({ accountMenuEl: null });
                  callbacks.handleChange(event, 'account');
                }}
                onClose={() => {
                  this.setState({ accountMenuEl: null });
                  setTimeout(() => callbacks.resetFocus(), 100);
                }}
              />
              }
            </>
            }
          </>
        }
      </RegListItem>
    );
  }

   onFieldBlur = (_e, _field) => {
     // this.props.callbacks.onFieldBlur(e, field);
   };

  onClickAway = () => {
    this.props.callbacks.onFieldBlur(true);
  };

  dateFieldOnKeyDown = (e) => {
    if (e.key === 'Enter') {
      this.props.callbacks?.maybeSaveTxnBeingEdited?.();
    }
  };

  dateFieldOnChange = (e) => this.props.callbacks?.handleChange?.(e, 'postedOn');

  // =============================================================================
  // renderFields
  // =============================================================================

  renderFields = (options) => {

    /* eslint-disable no-unused-vars */  // TODO remove this when showAccounts is used again
    const { wrapText, callbacks, txn, editable, lastRow, showAccounts, classes, scheduledTransactionsById,
      showBalance, longCats, currEditFieldName, showSplitWindow, usePayeeField, suggestCategoryForUncategorized,
      payeeAutoFillCat, payeeAutoFillMemo, payeeAutoFillAmount, payeeAutoFillTags,
      payeeShowFillInfoInMenu, txnCancelExtraColumn, noDateOnBankPending, sortBy } = this.props;

    const { currencySymbol } = this.state;
    const { showSplitsAndDetails, scriptId, showColor } = options;

    const enableAutoFocus = true;
    const amountProposedSign = (txn.id === '0' || Number(txn.amount) === 0) ? txnCategorySign(txn) : null;
    const wrapClass = wrapText ? 'wraptext' : '';

    const retRow = [];

    this.props.headerFields.forEach((field) => {

      const forceStatic = editable && !this.fieldIsEditable(txn, field);
      const fieldActive = (editable && !forceStatic && currEditFieldName === field);
      let staticValue = (<span>{'\u00A0'}</span>);

      const fieldKey = `${scriptId}_${field}_${fieldActive ? 'e' : ''}`;
      const editClass = fieldActive ? 'editable' : '';
      const hoverClass = (fieldActive || !this.fieldIsEditable(txn, field)) ? '' : classes.editHover;

      const attributes = {
        key: fieldKey,
        id: fieldKey,
        tabIndex: '0',
        onClick: () => callbacks.regFieldClick(field, txn),
        onKeyDown: (e) => !editable && this.itemKeydown(e, field, txn),
      };

      switch (field) {

        // ------------------------------------------------
        // MATCH FIELD
        // ------------------------------------------------
        case 'match':
          retRow.push(
            <RegListItem
              {...attributes}
              tabIndex={null}
              onClick={null}
              className={classNames(classes.iconColumn, 'nopoint')}
            >
              {SHOW_ALL && this.renderMatchState(txn, classes, callbacks.handleMenu)}
            </RegListItem>
          );
          break;

        // ------------------------------------------------
        // REVIEWED FIELD
        // ------------------------------------------------
        case 'reviewed':

          if (isUnacceptedScheduledTxn(txn)) {
            retRow.push(
              <RegListItem
                {...attributes}
                tabIndex={null}
                className={classNames(classes.iconButtonColumn, forceStatic ? 'nopoint' : '')}
              >
              </RegListItem>
            );
          } else {
            retRow.push(
              <RegListItem
                {...attributes}
                tabIndex={null}
                onClick={forceStatic ? null : () => {

                  if (!isAcme && this.props.userPreferences.windowsReviewedWarningEnabled) {
                    this.props.setUserPreference({ windowsReviewedWarningEnabled: false });
                    return this.props.showQHelp('windowsReviewed');
                  }
                  return callbacks.handleMenu('reviewed', txn);
                }}
                className={classNames(classes.iconButtonColumn, forceStatic ? 'nopoint' : '')}
              >
                {SHOW_ALL && this.renderReviewedState(txn, classes, fieldActive, forceStatic)}
              </RegListItem>
            );
          }
          break;

        // ------------------------------------------------
        // FLAG FIELD
        // ------------------------------------------------
        case 'userFlag':
          retRow.push(
            <RegListItem
              {...attributes}
              tabIndex={null}
              onClick={null}
              className={this.props.classes.iconButtonColumn}
            >
              <FlagField
                classes={{ iconRoot: this.props.classes.iconButtonColumn }}
                value={txn.userFlag}
                autoFocus={fieldActive}
                inputRef={fieldActive ? (input) => { this.focusField = input; } : null}
                editable={editable}
                onChange={(e) => callbacks.handleMenu('userFlag', txn, e.target.value)}
                show={(txn.userFlag && txn.userFlag !== 'NONE') || editable || this.state.showIcons}
              />
            </RegListItem>
          );
          break;

        // ------------------------------------------------
        // IGNORED FIELD
        // ------------------------------------------------
        case 'ignored':
          retRow.push(
            <RegListItem
              {...attributes}
              tabIndex={null}
              onClick={null}
              className={this.props.classes.iconButtonColumn}
            >
              <IgnoredField
                value={txn}
                autoFocus={fieldActive}
                inputRef={fieldActive ? (input) => { this.focusField = input; } : null}
                onChange={(e) => callbacks.handleMenu('ignored', txn, e.target.value)}
                classes={{ iconRoot: this.props.classes.iconButtonColumn }}
                show={(txn.isExcludedFromReports || txn.isExcludedFromF2S) || editable || this.state.showIcons}
              />
            </RegListItem>
          );
          break;

        // ------------------------------------------------
        // SELECT FIELD or RECURRING ICON FIELD
        // ------------------------------------------------
        case 'select':
          if (isUnacceptedScheduledTxn(txn) && !isAcme) {
            retRow.push(
              <RegListItem
                {...attributes}
                tabIndex={null}
                onClick={null}
                className={this.props.classes.iconButtonColumn}
              >
                {this.renderRecurringField({ txn, fieldActive, forceStatic, onChange: (val) => callbacks.actOnScheduledTxn(txn, val) })}
              </RegListItem>
            );
          } else {
            retRow.push(
              <RegListItem
                {...attributes}
                tabIndex={null}
                onClick={null}
                className={this.props.classes.iconButtonColumn}
              >
                {SHOW_ALL &&
                <QCheckbox
                  size={this.props.theme.components.register.checkboxSize}
                  color="primary"
                  inputProps={{ 'aria-label': 'Select or Unselect' }}
                  autoFocus={editable && currEditFieldName === 'select'}
                  disabled={forceStatic}
                  checked={this.props.selected}
                  inputRef={editable && !forceStatic && currEditFieldName === 'select' ?
                    (input) => {
                      this.focusField = input;
                    } : null}
                  onClick={() => this.onRowSelect(txn, !this.props.selected)}
                />
                }
              </RegListItem>
            );
          }
          break;

        // ------------------------------------------------
        // ACCOUNT COLOR FIELD
        // ------------------------------------------------
        case 'accountColor': {

          if (this.props.showAccountColors) {
            this.renderAccountField({
              attributes,
              retRow,
              fieldActive,
              wrapClass,
              callbacks,
              txn,
              classes,
              forceStatic,
              editable,
            });
          }
          break;
        }

        // ------------------------------------------------
        // ACCOUNT NAME FIELD
        // ------------------------------------------------
        case 'account': {

          if (showAccounts && !this.props.showAccountColors) {
            this.renderAccountField({
              attributes,
              retRow,
              fieldActive,
              wrapClass,
              callbacks,
              txn,
              classes,
              forceStatic,
              editable,
            });
          }
          break;
        }

        // ------------------------------------------------
        // POSTED_ON FIELD
        // ------------------------------------------------
        case 'postedOn': {

          const isPending = (isPendingTxn(txn) && noDateOnBankPending) && !isUnacceptedScheduledTxn(txn);
          const cname = isAcme ? classNames(classes.statusColumn, hoverClass, 'protectWidthDate') :
            classNames(this.props.classes.regItem, editClass, !isPending && hoverClass, 'protectWidthDate');

          retRow.push(

            <RegListItem
              {...attributes}
              className={cname}
            >
              {SHOW_ALL &&
              <>
                <DateField
                  disableKeyboardInput={isAcme}
                  showYear={sortBy !== 'date'}
                  disableUnderline={this.props.theme.components.register.noUnderline}
                  fieldId="postedOn"
                  editable={!forceStatic && editable && currEditFieldName === 'postedOn'}
                  value={txn.postedOn}
                  onKeyDown={this.dateFieldOnKeyDown}
                  onChange={this.dateFieldOnChange}
                  fontSize={this.props.theme.components.register.fontSize.default}
                  autoFocus={enableAutoFocus}
                  clickable={!forceStatic ? 'true' : null}
                  className={classNames(classes.dateField, ...(isPending && showColor ? [classes.pending] : []))}
                  inputRef={editable && !forceStatic && currEditFieldName === 'postedOn' ?
                    (input) => {
                      this.focusField = input;
                    } : null}
                />
              </>
              }
            </RegListItem>
          );
          break;
        }
        // ------------------------------------------------
        // TAGS FIELD
        // ------------------------------------------------
        case 'tags': {

          const tagStatic = makeTagsString(txn.tags, this.props.tagsAsHashes);
          const isSplit = isSplitTxn(txn);

          let tagFrag;
          if (!showSplitWindow && fieldActive && !isSplit) {
            tagFrag =
              <>
                <TagsField
                  disableUnderline={this.props.theme.components.register.noUnderline}
                  value={txn.tags}
                  onChange={(e) => callbacks.handleChange(e, 'tags')}
                  fieldId="tags"
                  autoFocus={enableAutoFocus}
                  inputRef={
                    (input) => {
                      this.focusField = input;
                    }
                  }
                />
              </>;
          } else if (isSplit || showSplitWindow) {
            tagFrag =
              <QTypography
                clickable
                thinFont
                className={classes.regItemCore}
              >
              </QTypography>;
          } else {
            tagFrag =
              <QTip
                wrapOnly
                title={this.props.wrapText ? null : tagStatic}
                wrapId={`${txn.id}-${field}`}
              >
                <QTypography
                  clickable={!forceStatic ? 'true' : null}
                  thinFont
                  className={classes.regItemCore}
                >
                  {tagStatic || staticValue}
                </QTypography>
              </QTip>;
          }


          retRow.push(
            <RegListItem
              {...attributes}
              className={classNames(this.props.classes.regItem,
                'flex2', fieldActive ? 'wraptext' : wrapClass, editClass, hoverClass)}
            >
              {SHOW_ALL && tagFrag}
            </RegListItem>
          );
          break;
        }

        // ------------------------------------------------
        // NOTES FIELD
        // ------------------------------------------------
        case 'notes':

          retRow.push(
            <RegListItem
              {...attributes}
              className={classNames(this.props.classes.regItem, 'flex2', wrapClass, editClass, hoverClass)}
            >
              {SHOW_ALL &&
              <>
                {editable && !forceStatic && currEditFieldName === 'notes' ?
                  <TextField
                    InputProps={{ disableUnderline: this.props.theme.components.register.noUnderline }}
                    className={classes.regInput}
                    onFocus={callbacks.handleFocus}
                    autoFocus={enableAutoFocus}
                    placeholder="Memo"
                    value={txn.memo || ''}
                    onChange={(e) => callbacks.handleChange(e, 'notes')}
                    onBlur={(e) => this.onFieldBlur(e, 'notes')}
                    inputRef={(input) => {
                      this.focusField = input;
                    }}
                  >
                  </TextField> :
                  <QTip
                    wrapOnly
                    title={this.props.wrapText ? null : txn.memo}
                    wrapId={`${txn.id}-${field}`}
                  >
                    <QTypography
                      clickable={!forceStatic ? 'true' : null}
                      thinFont
                      className={classes.regItemCore}
                    >
                      {txn.memo || staticValue}
                    </QTypography>
                  </QTip>
                }
              </>
              }
            </RegListItem>
          );
          break;

        // ------------------------------------------------
        // CHECK FIELD
        // ------------------------------------------------
        case 'check':

          if (txn.check && (txn.check.number || txn.check.memo)) {
            staticValue = txn.check.number || txn.check.memo;
          }

          retRow.push(
            <RegListItem
              {...attributes}
              className={classNames(this.props.classes.regItem, wrapClass, editClass, hoverClass)}
            >
              {SHOW_ALL &&
              <>
                {editable && !forceStatic && currEditFieldName === 'check' ?
                  <TextField
                    InputProps={{ disableUnderline: this.props.theme.components.register.noUnderline }}
                    className={classes.regInput}
                    onFocus={callbacks.handleFocus}
                    placeholder="Check #"
                    autoFocus={enableAutoFocus}
                    value={txn.check && (txn.check.number || txn.check.memo) || ''}
                    onChange={(e) => callbacks.handleChange(e, 'check')}
                    onBlur={(e) => this.onFieldBlur(e, field)}
                    inputRef={(input) => {
                      this.focusField = input;
                    }}
                  >
                  </TextField> :
                  <QTypography
                    clickable={!forceStatic ? 'true' : null}
                    thinFont
                    className={classes.regItemCore}
                  >
                    {staticValue}
                  </QTypography>
                }
              </>
              }
            </RegListItem>
          );
          break;

        // ------------------------------------------------
        // PAYEE FIELD
        // ------------------------------------------------
        case 'payee':

          if (usePayeeField) {

            let menuFields = 'payee';
            if (payeeShowFillInfoInMenu) {
              if (payeeAutoFillCat && !isSplitTxn(txn) && (!txn.coa || txn.coa.type === 'UNCATEGORIZED')) {
                menuFields += 'category';
              }
              if (Number(txn.amount) === 0 && payeeAutoFillAmount) {
                menuFields += 'amount';
              }
              if (!txn.memo && payeeAutoFillMemo) {
                menuFields += 'memo';
              }
              if (!txnHasTags(txn) && payeeAutoFillTags) {
                menuFields += 'tags';
              }
            }
            retRow.push(
              <RegListItem
                {...attributes}
                className={classNames(this.props.classes.regItem, 'flex2', wrapClass, editClass, hoverClass)}
              >
                {SHOW_ALL &&
                <>
                  {editable && !forceStatic && currEditFieldName === 'payee' ?
                    <PayeeField
                      disableUnderline={this.props.theme.components.register.noUnderline}
                      accountIds={this.props.accountIds}
                      menuShowFields={menuFields}
                      editable
                      fontSize={this.props.theme.components.register.fontSize.default}
                      onFocus={callbacks.handleFocus}
                      onBlur={(e) => this.onFieldBlur(e, field)}
                      autoFocus={enableAutoFocus}
                      value={{ payee: (txn.payee || '') }}
                      onChange={(e) => callbacks.handleChange(e, 'payee')}
                      inputRef={(input) => {
                        this.focusField = input;
                      }}
                    >
                    </PayeeField> :
                    <QTip
                      wrapOnly
                      title={this.props.wrapText ? null : txn.payee}
                      wrapId={`${txn.id}-${field}`}
                    >
                      <QTypography
                        clickable={!forceStatic ? 'true' : null}
                        thinFont
                        className={classes.regItemCore}
                      >
                        {txn.payee || staticValue}
                      </QTypography>
                    </QTip>}
                </>
                }

              </RegListItem>
            );

          } else {

            retRow.push(
              <RegListItem
                {...attributes}
                className={classNames(this.props.classes.regItem, 'flex2', wrapClass)}
              >
                {SHOW_ALL &&
                <>
                  {editable && !forceStatic && currEditFieldName === 'payee' ?
                    <TextField
                      className={classes.regInput}
                      onFocus={callbacks.handleFocus}
                      placeholder="Payee"
                      autoFocus={enableAutoFocus}
                      value={txn.payee || ''}
                      onChange={(e) => callbacks.handleChange(e, 'payee')}
                      inputRef={(input) => {
                        this.focusField = input;
                      }}
                    >
                    </TextField> :
                    <QTip
                      wrapOnly
                      title={this.props.wrapText ? null : txn.payee}
                      wrapId={`${txn.id}-${field}`}
                    >
                      <QTypography
                        clickable={!forceStatic ? 'true' : null}
                        thinFont
                        className={classes.regItemCore}
                      >
                        {txn.payee || staticValue}
                      </QTypography>
                    </QTip>}
                </>
                }
              </RegListItem>
            );
          }
          break;

        // ------------------------------------------------
        // CATEGORY FIELD
        // ------------------------------------------------
        case 'category':

          retRow.push(
            <RegListItem
              {...attributes}
              className={classNames(this.props.classes.regItem, 'flex2', wrapClass, editClass, hoverClass)}
              onClick={(!txn.split && forceStatic) ? null : () =>
                callbacks.regFieldClick('category', txn)}
            >
              {SHOW_ALL &&
                <RegCategoryField
                  txn={txn}
                  editable={editable && currEditFieldName === 'category'}
                  onChange={callbacks.handleChange}
                  forceStatic={forceStatic}
                  longCats={longCats}
                  wrapText={wrapText}
                  showSplitWindow={showSplitWindow}
                  inputRef={editable && !forceStatic && currEditFieldName === 'category' ?
                    (input) => {
                      this.focusField = input;
                    } : null}
                />
              }

            </RegListItem>
          );
          break;

        // ------------------------------------------------
        // SPLIT FIELD
        // ------------------------------------------------
        case 'split': {

          let suggestTxn = null;
          if (isUncategorizedTxn(txn) && suggestCategoryForUncategorized) {
            const suggestRecord = txn.payee && this.props.payeeCategoryMap ? this.props.payeeCategoryMap.get(txn.payee.toLowerCase()) : null;
            if (suggestRecord && !isSplitTxn(suggestRecord.txn)) {
              suggestTxn = suggestRecord.txn;
            }
          }
          retRow.push(
            <RegListItem
              {...attributes}
              tabIndex={null}
              className={classes.iconColumn}
              onClick={null}
            >
              {SHOW_ALL && !forceStatic &&
              <>
                {(isSplitTxn(txn) || editable) &&
                <QIconButton
                  aria-label="Split Transaction"
                  autoFocus={fieldActive}
                  buttonRef={fieldActive ? (input) => {
                    this.focusField = input;
                  } : null}
                  focusRipple
                  IconComponent={MUISplitIcon}
                  onClick={() => callbacks.regFieldClick('split', txn)}
                  size="small-target"
                  TooltipProps={{ enterDelay: 10 }}
                />
                }
                {!editable && suggestTxn &&
                <QIconButton
                  aria-label="Fast Categorize"
                  autoFocus={fieldActive}
                  disabled={forceStatic}
                  focusRipple
                  buttonRef={fieldActive ? (input) => {
                    this.focusField = input;
                  } : null}
                  IconComponent={FastCatIcon}
                  onClick={(!txn.split && forceStatic) ? null : () =>
                    callbacks.regFieldClick('categorySuggest', txn, suggestTxn)}
                  size="small-target"
                  tooltip={`Click to fast categorize as ${getFieldString('category', suggestTxn)}`}
                  TooltipProps={{ enterDelay: 10 }}
                />
                }
              </>
              }
            </RegListItem>
          );
          break;
        }

        // ------------------------------------------------
        // STATE FIELD
        // ------------------------------------------------
        case 'state': {

          const txnInfo = getTxnStateInfo(txn); // Linda is crazy
          const txnState = txnInfo.status;

          // For Acme, create a menu for scheduled instances
          let alternateMenu = null;

          // const billType = getSchedTxnType(txn).toLowerCase();

          if (isAcme && txnInfo.entry === 'scheduled' && txnInfo.status !== 'matched') {
            alternateMenu = [
              { label: `Delete recurring series`, value: 'deleteModel'},
              { label: `Delete reminder`, value: 'delete'},
            ];
            if (txnInfo.status === 'OVERDUE' || txnInfo.status === 'UPCOMING' || txnInfo.status === 'DUE') {
              alternateMenu.push({ label: 'Link to a transaction', value: 'match' });
            }
            alternateMenu.reverse();
          }

          retRow.push(
            <RegListItem
              {...attributes}
              className={classNames(classes.statusColumn, hoverClass)}
              onClick={null}
            >
              {SHOW_ALL &&
              <ClrField
                value={isAcme ? txnState : txn.state}
                className={classes.select}
                onChange={(e) => callbacks.handleMenu('state', txn, e.target.value)}
                alternateMenu={alternateMenu}
                inputRef={fieldActive ? (input) => {
                  this.focusField = input
                } : null
                }
                editable={this.fieldIsEditable(txn, field)}
                autoFocus={fieldActive}
                clearedIsBlank={isAcme}
              />
              }
            </RegListItem>
          );
          break;
        }

        // ------------------------------------------------
        // ATTACHMENT FIELD
        // ------------------------------------------------
        case 'attachment':
          retRow.push(
            <RegListItem
              {...attributes}
              tabIndex={null}
              className={classes.iconColumn}
              onClick={txn.attachments ? null : () => callbacks.handleMenu('addAttachments', txn)}
            >
              {txn.attachments && (txn.attachments.length > 0) && SHOW_ALL &&
                <QIconButton
                  aria-label="View Attachments"
                  autoFocus={fieldActive}
                  buttonRef={fieldActive ? (input) => { this.focusField = input; } : null}
                  focusRipple
                  IconComponent={AttachFileIcon}
                  onClick={() => callbacks.handleMenu('viewAttachments', txn)}
                  tooltip={`Transaction has ${txn.attachments.length} attachment${txn.attachments.length > 1 ? 's' : ''}`}
                  size="small-target"
                />
              }
            </RegListItem>
          );
          break;

        // ------------------------------------------------
        // EXPENSE FIELD
        // ------------------------------------------------
        case 'expense':
          if (this.props.doubleAmounts) {
            retRow.push(
              this.renderDoubleAmountField(
                'expense',
                this.fieldIsEditable(txn, field),
                enableAutoFocus,
                attributes,
              )
            );
          }
          break;

        // ------------------------------------------------
        // INCOME FIELD
        // ------------------------------------------------
        case 'income':
          if (this.props.doubleAmounts) {

            retRow.push(this.renderDoubleAmountField(
              'income',
              this.fieldIsEditable(txn, field),
              enableAutoFocus,
              attributes,
            ));
          }
          break;

        // ------------------------------------------------
        // AMOUNT FIELD
        // ------------------------------------------------
        case 'amount':
          if (!this.props.doubleAmounts) {
            retRow.push(
              <RegListItem
                {...attributes}
                className={classNames('amount', this.props.classes.regItem, 'protectWidth', editClass, hoverClass)}
              >
                {SHOW_ALL &&
                <AmountField
                  disableUnderline={this.props.theme.components.register.noUnderline}
                  clickable={this.fieldIsEditable(txn, field) ? 'true' : null}
                  thinFont
                  fontSize={this.props.theme.components.register.fontSize.default}
                  amountType="amount"
                  proposedSign={amountProposedSign}
                  lockInitialProposedSign
                  onChange={callbacks.handleChange}
                  onBlur={(e, fieldType, wasEnter) => {
                    callbacks.onAmountBlur(e, field, wasEnter);
                  }}
                  editable={this.fieldIsEditable(txn, field) && editable && currEditFieldName === 'amount'}
                  autoFocus={enableAutoFocus}
                  value={String(txn.amount)}
                  color= {(txn.amount > 0) ? 'green' : 'black'}
                  className={classNames(classes.regInput,'amount')}
                  currencySymbol={currencySymbol}
                  inputRef={this.fieldIsEditable(txn, field) && editable && currEditFieldName === 'amount' ?
                    (input) => {
                      this.focusField = input;
                    } : null}
                >
                </AmountField>
                }
              </RegListItem>
            );
          }
          break;

        // ------------------------------------------------
        // BALANCE FIELD
        // ------------------------------------------------
        case 'balance':
          if (showBalance) {

            const canEdit = this.fieldIsEditable(txn, field) && editable && currEditFieldName === 'balance' && this.props.editRunningBalance;

            retRow.push(
              <RegListItem
                {...attributes}
                tabIndex={null}
                className={classNames('amount', this.props.classes.regItem, canEdit ? editClass : '', this.props.editRunningBalance ? hoverClass : '')}
                onClick={this.fieldIsEditable(txn, field) ? () => callbacks.regFieldClick('balance', txn) : null}
              >
                {SHOW_ALL &&
                <>
                  {!lastRow ?
                    <QTip
                      title={canEdit ? `Adjust the balance for ${moment(txn.postedOn).format('MM/DD/YYYY')}` : null}
                      wrapId={`${txn.id}-${field}`}
                    >
                      <AmountField
                        disableUnderline={this.props.theme.components.register.noUnderline}
                        clickable={this.props.editRunningBalance && this.fieldIsEditable(txn, field) ? 'true' : null}
                        thinFont
                        amountType="balance"
                        onChange={callbacks.handleChange}
                        onBlur={(e, type) => {
                          callbacks.onAmountBlur(e, type);
                        }}
                        editable={canEdit}
                        autoFocus={enableAutoFocus}
                        value={String(txn.balance)}
                        color={this.getColorName(showColor, txn.balance)}
                        className={classNames(classes.regInput, 'amount')}
                        currencySymbol={currencySymbol}
                        inputRef={canEdit ?
                          (input) => {
                            this.focusField = input;
                          } : null}

                      >
                      </AmountField>
                    </QTip> :
                    ''
                  }
                </>
                }
              </RegListItem>
            );
          }
          break;

        // ------------------------------------------------
        // MENU FIELD
        // ------------------------------------------------
        case 'menu':
          retRow.push(
            <RegListItem
              {...attributes}
              tabIndex={null}
              className={this.props.classes.iconButtonColumn}
              onClick={null}
            >
              {SHOW_ALL && this.fieldIsEditable(txn, field) &&

                <QIconButton
                  autoFocus={fieldActive}
                  aria-label={!showSplitsAndDetails ? 'Show details' : 'Hide details'}
                  buttonRef={fieldActive ? (input) => {
                    this.focusField = input;
                  } : null}
                  focusRipple
                  IconComponent={!showSplitsAndDetails ? ExpandMoreIcon : ExpandLessIcon}
                  onClick={() => callbacks.handleMenu(showSplitsAndDetails ? 'hideDetails' : 'showDetails', txn)}
                  size="small-target"
                />
              }
            </RegListItem>
          );
          break;

        // ------------------------------------------------
        // SAVE FIELD
        // ------------------------------------------------
        case 'save':
          retRow.push(
            <RegListItem
              {...attributes}
              tabIndex={null}
              onClick={forceStatic ? null : () => callbacks.handleMenu('save', txn)}
              className={classNames(classes.iconButtonColumn, forceStatic ? 'nopoint skinny' : 'skinny')}
            >
              {editable && SHOW_ALL &&
                <QIconButton
                  aria-label="Save Transaction"
                  autoFocus={fieldActive}
                  focusRipple
                  buttonRef={fieldActive ? (input) => { this.focusField = input; } : null}
                  disabled={forceStatic}
                  IconComponent={SaveIcon}
                  IconProps={{
                    className: classNames(classes.reviewed, 'save'),
                  }}
                  size="small-target"
                  tooltip="Save Transaction"
                  TooltipProps={{ distance: 2 }}
                />
              }
            </RegListItem>
          );
          break;

        // ------------------------------------------------
        // CLOSE FIELD
        // ------------------------------------------------
        case 'close':
          if (txnCancelExtraColumn) {
            retRow.push(
              <RegListItem
                {...attributes}
                tabIndex={null}
                onClick={forceStatic ? null : () => callbacks.cancelEdit()}
                className={classNames(classes.iconButtonColumn, forceStatic ? 'nopoint skinny' : 'skinny')}
              >
                {editable && SHOW_ALL &&
                <QIconButton
                  aria-label="Set Reviewed State"
                  buttonRef={fieldActive ? (input) => { this.focusField = input; } : null}
                  disabled={forceStatic}
                  autoFocus={fieldActive}
                  focusRipple
                  IconComponent={CloseIcon}
                  IconProps={{
                    className: classNames(classes.reviewed, 'cancel'),
                    disabled: forceStatic,
                  }}
                  size="small-target"
                  tooltip="Cancel Editing"
                  TooltipProps={{ distance: 3 }}
                />
                }
              </RegListItem>
            );
          }
          break;


        default:
          log.error(`Bad Field ${field} sent to TransactionRow`);
          break;
      }
    });

    return retRow;
  };

  getColorClass = (showColor, amount) => {
    if (showColor) {
      return Number(amount) > 0 ? ' income' : ' expense';
    }
    return '';
  };
  getColorName = (showColor, amount) => {
    if (showColor) {
      return Number(amount) > 0 ? 'green' : 'red';
    }
    return 'black';
  };


  render() {
    const { callbacks, txn, editable, shade, lastRow, showSplitWindow, labelPendingAsFuture, noDateOnBankPending,
      simpleEdit, longCats, id, refFn, flashTx, scriptId, showGotoTransferInDetails, calendar } = this.props;

    SHOW_ALL = true;

    const panelOpen = (showSplitWindow || !simpleEdit) && editable;
    const showColor = !calendar;

    /* eslint-disable prefer-template */
    const className = (shade ? 'shade' : '') +
      (lastRow ? ' lastRow appear' : '') +
      (panelOpen ? ' panel' : '') +
      (editable ? ' editable appear' : '') +
      (` ${this.props.registerComfort}${isIe ? '-ie' : ''}`) +
      (moment(txn.postedOn).isAfter(moment()) && !labelPendingAsFuture && showColor ? ' pending' : '') +
      (isPendingTxn(txn) && process.env.PROJECT === 'acme' && showColor ? ' pending' : '') +
      // TODO temporary way to show the scheduled txn state
      (isUnacceptedScheduledTxn(txn) && showColor ? ' pending' : '') +
      (this.getColorClass(!showColor, txn.amount));

    const showSplitsAndDetails = editable && (showSplitWindow || !simpleEdit);
    const fieldsToRender = this.renderFields({ scriptId, showSplitsAndDetails, txn, lastRow, showColor });

    const ClickAwayComponent = editable ? ClickAwayListener : React.Fragment;
    const clickAwayProps = editable ? { onClickAway: this.onClickAway } : {};

    return (
      <RegTxList
        ref={refFn}
        aria-label={scriptId}
        id={id}
        key={`${txn.id}`}
        className={className}
        onMouseEnter={() => this.setState({ showIcons: true })}
        onMouseLeave={() => this.setState({ showIcons: false })}
      >
        <div {...(this.props.qcardId ? { id: this.props.qcardId} : {})}>
          {/* --------------------------------------------------- */}
          {/* -- ALL ROW FIELDS -- */}
          {/* --------------------------------------------------- */}

          <ClickAwayComponent
            {...clickAwayProps}
            key={`cac:${txn.id}`}
          >
            <RegTxListRow className={classNames(flashTx ? 'flashTx' : '', className)}>
              {fieldsToRender}
            </RegTxListRow>
          </ClickAwayComponent>

          {/* --------------------------------------------------- */}
          {/* -- SPLITS/DETAILS PANEL -- */}
          {/* --------------------------------------------------- */}
          {showSplitsAndDetails &&
            <SplitsAndDetailsPanel
              autoFocus
              txn={txn}
              closeFn={() => callbacks.hideModal('splits')}
              saveFn={this.saveTransaction}
              deleteFn={() => callbacks.handleMenu('delete', txn)}
              onAmountChange={callbacks.onAmountChange}
              longCats={longCats}
              showCurrencySymbol={this.props.showCurrencySymbol}
              onSizeChange={this.props.sizesChanged}
              showDetails={!simpleEdit}
              showSplits={showSplitWindow}
              unMatchAction={() => callbacks.handleMenu('unMatch', txn)}
              goToTransferAction={showGotoTransferInDetails ? () => callbacks.handleMenu('transfer', txn) : null}
              getSaveFn={callbacks.detailsRefSaveFn}
              splitSwitch={(on) => on ? callbacks.handleMenu('split', txn) : callbacks.handleMenu('hideSplit', txn)}
            >
            </SplitsAndDetailsPanel>
          }
        </div>
      </RegTxList>
    );
  }
}

TransactionRow.defaultProps = {
  shade: false,
  lastRow: false,
  editable: false,
  showBalance: true,
  showAccounts: false,
};

TransactionRow.propTypes = {
  theme: PropTypes.object,
  accountIds: PropTypes.object,
  refFn: PropTypes.func,
  sizesChanged: PropTypes.func,
  id: PropTypes.string,
  callbacks: PropTypes.object,
  txn: PropTypes.object,
  editable: PropTypes.bool,
  shade: PropTypes.bool,
  lastRow: PropTypes.bool,
  classes: PropTypes.object,
  simpleEdit: PropTypes.bool,
  onRowSelect: PropTypes.func,
  selected: PropTypes.bool,
  showBalance: PropTypes.bool,
  doubleAmounts: PropTypes.bool,
  editDownloaded: PropTypes.bool,
  showSplitWindow: PropTypes.bool,
  longCats: PropTypes.bool,
  wrapText: PropTypes.bool,
  flashTx: PropTypes.bool,
  onFocusField: PropTypes.func,
  showCurrencySymbol: PropTypes.bool,
  showAccounts: PropTypes.bool,
  registerComfort: PropTypes.string,
  currEditFieldName: PropTypes.string,
  headerFields: PropTypes.object,
  showAccountColors: PropTypes.bool,
  scriptId: PropTypes.string,
  calendar: PropTypes.bool,
  regEditableFields: PropTypes.object,
  sortBy: PropTypes.string,
  qcardId: PropTypes.string,

  // accountPreferences
  accountColorForId: PropTypes.string,

  // QCurrency
  getTxnCurrency: PropTypes.func,

  // QPrefs
  userPreferences: PropTypes.object,
  setUserPreference: PropTypes.func,

  // Generated
  usePayeeField: PropTypes.bool,
  suggestCategoryForUncategorized: PropTypes.bool,
  showGotoTransferInDetails: PropTypes.bool,
  payeeShowFillInfoInMenu: PropTypes.bool,
  payeeAutoFillCat: PropTypes.bool,
  payeeAutoFillAmount: PropTypes.bool,
  payeeAutoFillMemo: PropTypes.bool,
  payeeAutoFillTags: PropTypes.bool,
  txnCancelExtraColumn: PropTypes.bool,
  editRunningBalance: PropTypes.bool,
  payeeCategoryMap: PropTypes.object,
  datasetId: PropTypes.string,
  datasetsById: PropTypes.object,
  scheduledTransactionsById: PropTypes.object,
  transactionsByAccountId: PropTypes.object,
  dialogAlert: PropTypes.func,

  showQHelp: PropTypes.func,
  tagsAsHashes: PropTypes.bool,
  showCategorySettings: PropTypes.bool,
  labelPendingAsFuture: PropTypes.bool,
  noDateOnBankPending: PropTypes.bool,
};

function mapStateToProps(state, ownProps) {
  return {
    suggestCategoryForUncategorized: getFeatureFlags(state).get('suggestCategoryForUncategorized'),
    showGotoTransferInDetails: true, // getFeatureFlags(state).get('showGotoTransferInDetails'),
    payeeCategoryMap: getPayeesForAccounts(state, ownProps),
    accountColorForId: preferencesSelectors.accountColorForId(state, ownProps.txn.accountId),
    usePayeeField: getFeatureFlags(state).get('usePayeeField'),
    payeeShowFillInfoInMenu: getFeatureFlags(state).get('payeeShowFillInfoInMenu'),
    payeeAutoFillCat: getFeatureFlags(state).get('payeeAutoFillCat'),
    payeeAutoFillAmount: getFeatureFlags(state).get('payeeAutoFillAmount'),
    payeeAutoFillMemo: getFeatureFlags(state).get('payeeAutoFillMemo'),
    payeeAutoFillTags: getFeatureFlags(state).get('payeeAutoFillTags'),
    txnCancelExtraColumn: getFeatureFlags(state).get('txnCancelExtraColumn'),
    enableWindowsReviewedColumn: getFeatureFlags(state).get('enableWindowsReviewedColumn'),
    editRunningBalance: getFeatureFlags(state).get('editRunningBalance'),
    tagsAsHashes: getFeatureFlags(state).get('tagsAsHashes'),
    showCategorySettings: getFeatureFlags(state).get('showCategorySettings'),
    labelPendingAsFuture: getFeatureFlags(state).get('labelPendingAsFuture'),
    noDateOnBankPending: getFeatureFlags(state).get('noDateOnBankPending'),
    datasetId: getDatasetId(state),
    datasetsById: getDatasetsById(state),
    scheduledTransactionsById: getScheduledTransactions(state),
    transactionsByAccountId: getTransactionsByAccountId(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
  };
}

export default compose(
  withStyles(styles, { withTheme: true }),
  QCurrency(),
  QHelp(),
  QDialogs(),
  QPreferences(),
  connect(mapStateToProps, mapDispatchToProps)
)(TransactionRow);
